import React from 'react';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { roleConfig } from '../config/roleConfig';

export default function RolesPage() {
  return <CRUDManager config={roleConfig} />;
}
